/**
 * Created by Carsten Bühler
 * User: c.buehler on 29.04.2016
 * Copyright: xdot GmbH 2015
 */

'use strict';

import React, { useRef } from 'external/react';

import {
    AmdRequireComponent,
    AppContext,
    CustomModal,
    CustomModalBody,
    DataLinkContainer,
    FluxContainer
} from 'plugin/liferay-widgets-react-web';
import ModalActions from '../actions/ModalActions';

import { getModalStore } from '../stores/StoreFactory';

const ModalStore = getModalStore(AppContext);

const DetailsModal = (props) => {
    const { store, className, context, dataName, onClose, size } = props;
    const RendererHoc = useRef();
    
    return (
        <CustomModal 
            show={true} 
            onHide={onClose} 
            context={context}
            size={size}
        >
            <CustomModalBody>
                <AmdRequireComponent dependencies={['DetailsRenderer/' + className]}>
                    {
                        (Renderer) => {
                            let R_Hoc = RendererHoc.current;
                            if (!R_Hoc ||
                                R_Hoc.store !== store ||
                                R_Hoc.Renderer !== Renderer) 
                            {
                                if (R_Hoc) {
                                    console.warn('ReCreate RendererHoc! ', R_Hoc.store, R_Hoc.Renderer, store, Renderer);
                                }
                                RendererHoc.current = R_Hoc = DataLinkContainer.link(Renderer, 'item', store);
                                R_Hoc.store = store;
                                R_Hoc.Renderer = Renderer;
                            }

                            return <R_Hoc {...props} dataName={null} item={dataName}/>;
                        }
                    }
                </AmdRequireComponent>
            </CustomModalBody>
        </CustomModal>
    );
};

class ModalRenderer extends React.Component {

    constructor(props){
        super(props);
        this.state = { activeTabKey: 'tabAttachedChangeRecords' };
    }

    static getStores(){
        return [ModalStore];
    }

    static calculateState(){
        return {
            modals: ModalStore.getModals()
        };
    }

    closeModal(modal){
        ModalActions.hideModal(modal.className, modal.dataName);
    }

    render(){
        return this.state.modals.map((modal) => {
            return (
                <DetailsModal
                    {...{ ...this.props, ...modal.props }}
                    className={modal.className}
                    context={modal.context}
                    dataName={modal.dataName}
                    store={modal.store}
                    key={modal.key}
                    onClose={this.closeModal.bind(this, modal)}
                />
            );
        });
    }
}

export default FluxContainer.create(ModalRenderer);



// WEBPACK FOOTER //
// ./js/controllerViews/ModalRenderer.jsx